// Hero composition: stack of real CLED book covers, tilted and overlapped
export const HeroStack = () => {
  const covers = [
    { src: "/covers/les-chaines.jpg", alt: "Les chaînes et les espérances", rotate: -8, x: 0, y: 0, z: 30 },
    { src: "/covers/noces-de-paix.jpg", alt: "Noces de paix à Kanou", rotate: 5, x: 80, y: 40, z: 20 },
    { src: "/covers/yili.jpg", alt: "Yili : Alerte et jubilation", rotate: -3, x: 160, y: 80, z: 10 },
    { src: "/covers/femme-fatale.jpg", alt: "Femme fatale", rotate: 8, x: 40, y: 160, z: 25 },
    { src: "/covers/ndoumba.jpg", alt: "Les aventures de Ndoumba", rotate: -5, x: 140, y: 200, z: 15 },
    { src: "/covers/discours-sociaux.jpg", alt: "Les discours sociaux sur le corps", rotate: 6, x: 20, y: 280, z: 5 },
  ];
  return (
    <div className="relative w-full h-[500px] md:h-[640px]" data-testid="hero-stack">
      {covers.map((c, i) => (
        <div
          key={i}
          className="absolute shadow-2xl transition-transform duration-500 hover:!rotate-0 hover:scale-105 hover:z-50"
          style={{
            left: `${c.x}px`,
            top: `${c.y}px`,
            transform: `rotate(${c.rotate}deg)`,
            zIndex: c.z,
            width: "220px",
            height: "320px",
          }}
        >
          <img
            src={c.src}
            alt={c.alt}
            className="w-full h-full object-cover"
            loading="eager"
          />
        </div>
      ))}
    </div>
  );
};
